import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Box, Typography } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import StyledModal from "../../Modals/StyledModal/StyledModal";
import PrimaryButton from "../../Buttons/PrimaryButton/PrimaryButton";
import SecondaryButton from "../../Buttons/SecondaryButton/SecondaryButton";
import InlineIconButton from "../../Buttons/InlineIconButton/InlineIconButton";
import { handleAltEnter } from "../../../utils/keyboardShortcutHelpers";

export default function DeleteModal({
  type,
  isLoading,
  handleDelete,
  disabled,
  open,
  setOpen,
  disableIcon
}) {
  const [title, setTitle] = useState("Delete item");

  const setInitialValues = () => {
    if (type) {
      let modalTitle = "Delete " + type;
      setTitle(modalTitle);
    }
  };

  const handleReset = () => {
    setInitialValues();
  };

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleCancel = () => {
    handleReset();
    handleClose();
  };

  const handleConfirm = () => {
    handleDelete();
  };

  useEffect(() => {
    if (!isLoading) handleClose();
  }, [isLoading]);

  useEffect(() => {
    setInitialValues();
  }, []);

  return (
    <Box onKeyUp={(e) => handleAltEnter(e, isLoading, handleConfirm)}>
      {!disableIcon &&
        <InlineIconButton
          onClick={handleOpen}
          disabled={disabled}
          icon={DeleteIcon}
          buttonColor="grey"
        />
      }
      <StyledModal
        label={title}
        title={title}
        open={open}
        handleClose={handleClose}
      >
        <Box sx={{ display: "flex" }}>
          <Box sx={{ marginRight: "60px" }}>
            <Typography>
              Are you sure you want to delete this {type ?? "item"}?
            </Typography>
          </Box>
        </Box>
        <Box sx={{ display: "flex", marginTop: "30px" }}>
          <Box sx={{ marginLeft: "auto", marginRight: "20px" }}>
            <SecondaryButton
              label="Cancel"
              onClick={handleCancel}
              disabled={isLoading}
            />
          </Box>
          <PrimaryButton
            label="Confirm"
            width="64px"
            onClick={handleConfirm}
            isLoading={isLoading}
            disabled={isLoading}
          />
        </Box>
      </StyledModal>
    </Box>
  );
}

DeleteModal.propTypes = {
  type: PropTypes.string,
  isLoading: PropTypes.bool.isRequired,
  handleDelete: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
  disableIcon: PropTypes.bool
};